import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  CreateBreakoutSessionsDto,
  PublicSession,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const openBreakoutSession = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: CreateBreakoutSessionsDto;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/breakout-rooms`,
    body,
  );
  return response.data;
};

function useOpenBreakoutSession(
  mutationOptions?: Partial<
    UseMutationOptions<
      PublicSession,
      HttpError,
      { sessionId: string; body: CreateBreakoutSessionsDto }
    >
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId, body }) =>
      openBreakoutSession({ sessionId, body }),
    ...mutationOptions,
  });
}

const closeBreakoutSession = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/close-breakout-rooms`,
  );
  return response.data;
};

function useCloseBreakoutSession(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => closeBreakoutSession({ sessionId }),
    ...mutationOptions,
  });
}

export { useCloseBreakoutSession, useOpenBreakoutSession };
